import { MoreOutlined } from '@ant-design/icons';
import WithHyperLink from 'library/hoc/withHyperLink';
import { DeleteAdminModal } from 'zComponents/molecules';
import { Card, Col, Dropdown, Empty, Row, Typography } from 'zui/Antd';

const { Text } = Typography;

const EntityAdminTab = ({ admin, data, type }) => {
	const items = (item) => [
		{
			key: 'Revoke admin permission',
			label: <DeleteAdminModal data={item} type={type} />
		}
	];

	const NameWithLink = WithHyperLink((a) => {
		return <Text>{a.children}</Text>;
	});

	return (
		<Row gutter={[8, 8]}>
			{admin && admin.length > 0 ? (
				admin.map((item, key) => (
					<Col key={key} lg={12} md={12} sm={12} xs={12}>
						<Card
							size='small'
							title={item.adminType ? item.adminType : 'Default'}
							extra={
								<Dropdown
									menu={{
										items: items(item)
									}}
									trigger={['click']}
								>
									<MoreOutlined />
								</Dropdown>
							}
							style={{ height: '100%' }}
						>
							<NameWithLink type={'person'} dataID={item.personID}>
								{item.displayName}
							</NameWithLink>

							<Text>{item.email}</Text>
						</Card>
					</Col>
				))
			) : (
				<Col span={24}>
					<Empty
						image={Empty.PRESENTED_IMAGE_SIMPLE}
						description={<span>No Admin Permission Granted</span>}
					/>
				</Col>
			)}
		</Row>
	);
};

export default EntityAdminTab;
